import { render, staticRenderFns } from "./UiDesignView.vue?vue&type=template&id=3f476d39&scoped=true"
import script from "./UiDesignView.vue?vue&type=script&lang=js"
export * from "./UiDesignView.vue?vue&type=script&lang=js"
import style0 from "./UiDesignView.vue?vue&type=style&index=0&id=3f476d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f476d39",
  null
  
)

export default component.exports